/**
 * Infobar selectors
 */

import {createSelector} from 'reselect';

const makeSelectDomain = () => (state) => state.get('announcement');

const makeSelectAnnouncement = () => createSelector(
    makeSelectDomain(),
    (domainState) => domainState.toJS()
);

const makeSelectAnnouncementBarOpen = () => createSelector(
    makeSelectDomain(),
    (domainState) => domainState && domainState.get('openBar')
);

const makeSelectAnnouncementDialogOpen = () => createSelector(
    makeSelectDomain(),
    (domainState) => domainState && domainState.get('openDialog')
);

const makeSelectAnnouncementId = () => createSelector(
    makeSelectDomain(),
    (domainState) => domainState && domainState.get('id')
);

const makeSelectAnnouncementName = () => createSelector(
    makeSelectDomain(),
    (domainState) => domainState && domainState.get('name')
);


const makeSelectAnnouncementContent = () => createSelector(
    makeSelectDomain(),
    (domainState) => domainState && domainState.get('content')
);

const makeSelectAnnouncementLink = () => createSelector(
    makeSelectDomain(),
    (domainState) => domainState && domainState.get('link')
);

export default makeSelectAnnouncement;
export {
    makeSelectAnnouncementBarOpen,
    makeSelectAnnouncementDialogOpen,
    makeSelectAnnouncementId,
    makeSelectAnnouncementName,
    makeSelectAnnouncementContent,
    makeSelectAnnouncementLink,
};
